<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold">Create User Account</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </template>
    <section class="page-section pt-2">
      <div class="container-fluid">
        <div class="grid">
          <div class="md:col-9 sm:col-12 comp-grid">
            <div class="">
              <div class="">
                <div>
                  <form
                    ref="observer"
                    tag="form"
                    @submit.prevent="submitForm()"
                    class=""
                    :class="{ card: !isSubPage }"
                  >
                    <div class="grid">
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">First Name *</div>
                        <div id="ctrl-first_name-holder">
                          <InputText
                            ref="ctrlfirst_name"
                            v-model.trim="formData.first_name"
                            pattern="^[A-Za-z-', ]+$"
                            label="First Name"
                            type="text"
                            placeholder="Enter First Name"
                            class="w-full"
                            :class="getErrorClass('first_name')"
                          >
                          </InputText>
                          <small
                            v-if="isFieldValid('first_name')"
                            class="p-error"
                            >{{ getFieldError("first_name") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">Last Name *</div>
                        <div id="ctrl-last_name-holder">
                          <InputText
                            ref="ctrllast_name"
                            v-model.trim="formData.last_name"
                            pattern="^[A-Za-z-', ]+$"
                            label="Last Name"
                            type="text"
                            placeholder="Enter Last Name"
                            class="w-full"
                            :class="getErrorClass('last_name')"
                          >
                          </InputText>
                          <small
                            v-if="isFieldValid('last_name')"
                            class="p-error"
                            >{{ getFieldError("last_name") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">Email *</div>
                        <div id="ctrl-email-holder">
                          <check-duplicate
                            v-model="formData.email"
                            check-path="components_data/users_email_exist/"
                            v-slot="checker"
                          >
                            <InputText
                              ref="ctrlemail"
                              @blur="checker.check"
                              :loading="checker.loading"
                              v-model.trim="formData.email"
                              label="Email"
                              type="email"
                              placeholder="Enter Email"
                              maxlength="40"
                              class="w-full"
                              :class="getErrorClass('email')"
                            >
                            </InputText>
                            <small
                              v-if="isFieldValid('email')"
                              class="p-error"
                              >{{ getFieldError("email") }}</small
                            >
                            <small
                              v-if="!checker.loading && checker.exist"
                              class="p-error"
                            >
                              Email is already taken</small
                            >
                            <small v-if="checker.loading" class="text-500"
                              >Checking...</small
                            >
                          </check-duplicate>
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">
                          Telephone Ext. *
                        </div>
                        <div id="ctrl-telephone-holder">
                          <InputText
                            ref="ctrltelephone"
                            v-model.trim="formData.telephone"
                            maxlength="12"
                            minlength="3"
                            pattern="^[0-9]+$"
                            label="Telephone"
                            type="text"
                            placeholder="Enter Telephone Ext."
                            class="w-full"
                            :class="getErrorClass('telephone')"
                          >
                          </InputText>
                          <small
                            v-if="isFieldValid('telephone')"
                            class="p-error"
                            >{{ getFieldError("telephone") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">Region *</div>
                        <div id="ctrl-region-holder">
                          <api-data-source
                            api-path="components_data/region_option_list"
                          >
                            <template v-slot="req">
                              <Dropdown
                                class="w-full"
                                :class="getErrorClass('region')"
                                :loading="req.loading"
                                optionLabel="label"
                                optionValue="value"
                                ref="ctrlregion"
                                v-model="formData.region"
                                :options="req.response"
                                label="Region"
                                placeholder="Select ..."
                              >
                              </Dropdown>
                              <small
                                v-if="isFieldValid('region')"
                                class="p-error"
                                >{{ getFieldError("region") }}</small
                              >
                            </template>
                          </api-data-source>
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">District *</div>
                        <div id="ctrl-district-holder">
                          <api-data-source
                            @loaded="formData.district = ''"
                            :load-on-mount="false"
                            :api-path="`components_data/district_option_list?lookup_region=${formData.region}`"
                          >
                            <template v-slot="req">
                              <Dropdown
                                class="w-full"
                                :class="getErrorClass('district')"
                                :loading="req.loading"
                                optionLabel="label"
                                optionValue="value"
                                ref="ctrldistrict"
                                v-model="formData.district"
                                :options="req.response"
                                label="District"
                                hint="Please select region before selecting district"
                                placeholder="Select ..."
                              >
                              </Dropdown>
                              <small
                                v-if="isFieldValid('district')"
                                class="p-error"
                                >{{ getFieldError("district") }}</small
                              >
                            </template>
                          </api-data-source>
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">
                          User Role (Access Level) *
                        </div>
                        <div id="ctrl-user_role-holder">
                          <api-data-source
                            api-path="components_data/user_role_option_list"
                          >
                            <template v-slot="req">
                              <Dropdown
                                class="w-full"
                                :class="getErrorClass('user_role')"
                                :loading="req.loading"
                                optionLabel="label"
                                optionValue="value"
                                ref="ctrluser_role"
                                v-model="formData.user_role"
                                :options="req.response"
                                label="User Role  (Access Level)"
                                placeholder="Select ..."
                              >
                                <template #option="slotProps">
                                  <div class="flex align-items-center">
                                    <div
                                      class="ml-2"
                                      v-if="slotProps.option.image"
                                    >
                                      <Avatar
                                        :image="
                                          $utils.setImgUrl(
                                            slotProps.option.image
                                          )
                                        "
                                      />
                                    </div>
                                    <div>
                                      <div>{{ slotProps.option.label }}</div>
                                      <div
                                        v-if="slotProps.option.caption"
                                        class="text-sm text-500"
                                      >
                                        {{ slotProps.option.caption }}
                                      </div>
                                    </div>
                                  </div>
                                </template>
                              </Dropdown>
                              <small
                                v-if="isFieldValid('user_role')"
                                class="p-error"
                                >{{ getFieldError("user_role") }}</small
                              >
                            </template>
                          </api-data-source>
                        </div>
                      </div>
                    </div>
                    <div v-if="showSubmitButton" class="text-center my-3">
                      <Button
                        class="p-button-primary p-button-rounded"
                        type="submit"
                        label="Submit"
                        icon="pi pi-send"
                        :loading="saving"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { computed, reactive, toRefs, onMounted } from "vue";
import useVuelidate from "@vuelidate/core";
import { required, email } from "@/services/validators";
import { utils } from "@/utils";
import { useApp } from "@/composables/app.js";
import { useAddPage } from "@/composables/addpage.js";
//[--PAGE-IMPORT-STATEMENT--]
const props = defineProps({
  pageName: {
    type: String,
    default: "users",
  },
  routeName: {
    type: String,
    default: "usersadd",
  },
  apiPath: {
    type: String,
    default: "users/add",
  },
  submitButtonLabel: {
    type: String,
    default: "Submit",
  },
  formValidationError: {
    type: String,
    default: "Form is invalid",
  },
  formValidationMsg: {
    type: String,
    default: "Please complete the form",
  },
  msgAfterSave: {
    type: String,
    default: "User added successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showSubmitButton: {
    type: Boolean,
    default: true,
  },
  redirect: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
  pageData: {
    // use to set formData default values from another page
    type: Object,
    default: () => {},
  },
});
const app = useApp();
const formDefaultValues = {
  first_name: "",
  last_name: "",
  email: "",
  telephone: "",
  region: "",
  district: "",
  user_role: "",
};
const formData = reactive({ ...formDefaultValues });
//form validation rules
const rules = computed(() => {
  return {
    first_name: { required },
    last_name: { required },
    email: { required, email },
    telephone: { required },
    region: { required },
    district: { required },
    user_role: { required },
  };
});
const v$ = useVuelidate(rules, formData); // form validation
const page = useAddPage({ props, formData, v$, beforeSubmit, afterSubmit });
// perform custom validation before submit form
// set custom form fields
// return false if validation fails
function beforeSubmit() {
  return true;
}
// after form submited to api
// reset form data.
// redirect to another page
function afterSubmit(response) {
  app.flashMsg(props.msgAfterSave);
  page.setFormDefaultValues(); //reset form data
  if (props.redirect) app.navigateTo(`/users`);
}
//page state
const {
  submitted, // form submitted state - Boolean
  saving, // form api submiting state - Boolean
  pageReady, // if api data loaded successfully
} = toRefs(page.state);
//page methods
const {
  submitForm, //submit form data to api
  getErrorClass, // return error class if field is invalid- args(fieldname)
  getFieldError, //  get validation error message - args(fieldname)
  isFieldValid, // check if field is validated - args(fieldname)
  // map api datasource  to Select options label-value
} = page.methods;
onMounted(() => {
  const pageTitle = "Create New User Account";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
});
// expose page object for other components access
defineExpose({
  page,
});
</script>
<style scoped></style>
<style scoped></style>
